import { DetailTabModel } from '@y42/feature/detail-view';
import { datasourceTableIcon } from '@y42/feature/icons';

export const ModelingTabs: DetailTabModel[] = [
  {
    path: 'overview',
    logo: datasourceTableIcon,
    label: 'Model definition',
    description:
      'Edit the table structure of this data source. Each data source type has a different structure interface',
  },
];

export const IntegrationTabs: DetailTabModel[] = [
  {
    path: 'overview',
    logo: datasourceTableIcon,
    label: 'Integration setup',
    description:
      'Edit the table structure of this data source. Each data source type has a different structure interface',
  },
];
